import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import gql from "graphql-tag";
import { Beforeunload } from "react-beforeunload";
import RizeeLogo from "../../../images/rizee_logo.png";
import "./AdmissionTest.scss";
import AdmissionDetailedResultPdf from "./AdmissionDetailedResultPdf";

const SUBJECT_MAP = {
  1: "Biology",
  2: "Physics",
  3: "Chemistry",
  4: "Maths",
};

// ─────────────────────────────────────────────────────────────────────────────
// GRAPHQL QUERIES & MUTATIONS
// ─────────────────────────────────────────────────────────────────────────────
const GET_ADMISSION_TEST_PATTERN = gql`
  query($admission_test_id: Int!) {
    getAdmissionTestPattern(admission_test_id: $admission_test_id) {
      duration
      marks
      sections {
        id
        section_name
        starting_no
        ending_no
        subject_id
        no_of_marks
        no_of_neg_marks
        is_advanced
        no_of_qus_answer
        advanced_section {
          question_options
          correct_4
          correct_3
          correct_2
          correct_1
          correct_0
          correct_marks
          negative_marks
        }
      }
    }
  }
`;

const GET_ADMISSION_TEST_QUESTIONS = gql`
  query ($admission_test_id: Int!) {
    getAdmissionTestQuestions(admission_test_id: $admission_test_id) {
      id
      admission_test_id
      question
      option1
      option2
      option3
      option4
      option5
      # answer removed for security
      explanation
      qtype
      compquestion
      list1type
      list2type
      listtype
      listname
      mat_question
      mat_que_paragraph
      mat_que_footer
      inputquestion
      answer # requested by user for some logic (usually answer is hidden, but user schema has it)
      timeduration
      order_by
      subject
      complexity
    }
  }
`;

const SUBMIT_ADMISSION_TEST_SESSION = gql`
  mutation (
    $enquiry_form_master_id: Int!
    $admission_test_id: Int!
    $attempts: [AdmissionAttemptInput!]
    $is_completed: Int
    $pdf_base64: String
    $filename: String
  ) {
    submitAdmissionTestSession(
      enquiry_form_master_id: $enquiry_form_master_id
      admission_test_id: $admission_test_id
      attempts: $attempts
      is_completed: $is_completed
      pdf_base64: $pdf_base64
      filename: $filename
    ) {
      id
      is_completed
      correct
      wrong
      total_marks_gained
      total_marks
      subject_analytics {
        subject_id
        subject_name
        correct
        wrong
        unattempted
        marks_gained
        total_marks
      }
    }
  }
`;

const START_ADMISSION_TEST_SESSION = gql`
  mutation($enquiry_form_master_id: Int!, $admission_test_id: Int!) {
    startAdmissionTestSession(
      enquiry_form_master_id: $enquiry_form_master_id
      admission_test_id: $admission_test_id
    ) {
      id
      enquiry_form_master_id
      admission_test_id
      is_completed
      inserted_at
      remaining_time
    }
  }
`;

const GET_ADMISSION_SESSION_QUESTIONS = gql`
  query($admission_test_session_id: Int!) {
    getAdmissionSessionQuestions(admission_test_session_id: $admission_test_session_id) {
      question_id
      attempt_answer
      question_time
      status
    }
  }
`;

const SYNC_ADMISSION_SESSION_QUESTION = gql`
  mutation(
    $admission_test_session_id: Int!
    $question_id: Int!
    $attempt_answer: String
    $question_time: Int
    $status: Int
  ) {
    syncAdmissionSessionQuestion(
      admission_test_session_id: $admission_test_session_id
      question_id: $question_id
      attempt_answer: $attempt_answer
      question_time: $question_time
      status: $status
    ) {
      id
      question_id
      status
    }
  }
`;

const DEFAULT_EXAM_CONFIG = {
  exam_duration_min: 180,
  instructions:
    "Read all questions carefully and select the correct answer.",
  exam_type: "admission_test",
  is_partexam: false,
  exam_status: "active",
};

let stopExamStatus = "0";

// ─────────────────────────────────────────────────────────────────────────────
// COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
class AdmissionTestExam extends Component {
  constructor(props) {
    super(props);

    let resumeExam = false;
    if (props.skipInstructions) resumeExam = true;
    else if (props.history?.location?.state?.resumeExam === true)
      resumeExam = true;
    else if (localStorage.getItem("resumeExam") === "true") resumeExam = true;

    // Read session from localStorage (set during login)
    const storedSession = localStorage.getItem("admissionGuest");
    const session = storedSession ? JSON.parse(storedSession) : {};

    this.state = {
      questions: [],
      currentIndex: 0,
      activeSubject: "",
      examConfig: DEFAULT_EXAM_CONFIG,
      timeLeft: DEFAULT_EXAM_CONFIG.exam_duration_min * 60,
      timeWarning: false,
      showConfirm: false,
      showInstructions: !resumeExam,
      examStarted: resumeExam,
      submitStatus: 1,
      isOnline: navigator.onLine,
      resumeExam,
      loadingQuestions: true,
      loadError: "",
      session,
      submitting: false,
      isGeneratingPdf: false,
      resultDataForPdf: null,
    };
    this.pdfRef = React.createRef();
  }



  // ─── LIFECYCLE ─────────────────────────────────────────────────────────────
  componentDidMount() {
    window.onpopstate = () =>
      this.props.history.replace("/admission-test-home");
    window.addEventListener("contextmenu", (e) => e.preventDefault());
    window.addEventListener("selectstart", (e) => {
      e.preventDefault();
      e.returnValue = "false";
    });

    let session = this.props.location?.state;

    // Fallback to localStorage if state is missing
    if (!session || !session.enquiry_form_master_id) {
      const stored = localStorage.getItem('admissionGuest');
      if (stored) {
        try { session = JSON.parse(stored); } catch (e) { }
      }
    }

    if (!session || !session.enquiry_form_master_id) {
      console.warn("No valid session found, redirecting to home.");
      this.props.history.replace("/admission-test-home");
      return;
    }

    this.setState({ session }, () => {
      this.initializeApp().catch(err => {
        console.error("Critical error during initialization", err);
      });
    });

    // Autosave timer
    this.autoSaveTimer = setInterval(this.autoSaveProgress, 25000);
  }

  initializeApp = async () => {
    // 1. Fetch/Init DB Session
    const dbSession = await this.getDBSession();

    // 2. Update state with session and timer (wait for it)
    await new Promise(resolve => {
      this.setState({
        dbSession,
        timeLeft: dbSession && dbSession.remaining_time !== undefined ? dbSession.remaining_time : this.state.timeLeft
      }, resolve);
    });

    // 3. Fetch Questions (passing explicit session ID)
    await this.fetchQuestions(this.state.dbSession?.id);

    // 4. Start Exam if requested (Timer now starts with correct timeLeft)
    if (this.props.skipInstructions || this.state.resumeExam) {
      this.startExam();
    }
  }

  getDBSession = async () => {
    const { session } = this.state;
    if (!session || !session.enquiry_form_master_id) return null;

    try {
      const res = await this.props.client.mutate({
        mutation: START_ADMISSION_TEST_SESSION,
        variables: {
          enquiry_form_master_id: parseInt(session.enquiry_form_master_id),
          admission_test_id: parseInt(session.admission_test_id)
        }
      });
      return res.data.startAdmissionTestSession;
    } catch (e) {
      console.error("Failed to initialize session from DB", e);
      return null;
    }
  }


  /**
   * Selection for SCQ (Single Choice)
   */
  selectOption = (question_id, optionLabel) => {
    const { questions } = this.state;
    const qIndex = questions.findIndex((q) => q.id === question_id);
    if (qIndex === -1) return;

    const updatedQuestions = [...questions];

    // Store with trailing comma (e.g., "A,")
    const formattedLabel = optionLabel + ",";

    if (updatedQuestions[qIndex].attempted === formattedLabel) {
      // updatedQuestions[qIndex].attempted = null; // optional clear
    } else {
      updatedQuestions[qIndex].attempted = formattedLabel;
    }

    // Preserve 'review' status if already marked; otherwise set answered
    if (updatedQuestions[qIndex].status !== "review") {
      updatedQuestions[qIndex].status = "answered";
    }

    this.setState({ questions: updatedQuestions }, () => {
      this.autoSaveProgress();
      this.syncQuestionProgress(qIndex);
    });
  };

  /**
   * Selection for MSQ (Multiple Choice)
   */
  selectOptionMulti = (question_id, optionLabel) => {
    const { questions } = this.state;
    const qIndex = questions.findIndex((q) => q.id === question_id);
    if (qIndex === -1) return;

    const updatedQuestions = [...questions];
    // Remove trailing comma if exists before splitting
    let currentAttemptStr = updatedQuestions[qIndex].attempted ? String(updatedQuestions[qIndex].attempted).replace(/,$/, "") : "";
    let currentAttempts = currentAttemptStr ? currentAttemptStr.split(",") : [];

    // Remove empty strings if any
    currentAttempts = currentAttempts.filter(a => a !== "" && a !== "null");

    if (currentAttempts.includes(optionLabel)) {
      // Remove it
      currentAttempts = currentAttempts.filter(a => a !== optionLabel);
    } else {
      // Add it
      currentAttempts.push(optionLabel);
    }

    // Join back and add trailing comma (e.g., "A,C,")
    updatedQuestions[qIndex].attempted = currentAttempts.length > 0 ? currentAttempts.sort().join(",") + "," : null;

    // Only set status to answered/skip if not in 'review'
    if (updatedQuestions[qIndex].status !== "review") {
      updatedQuestions[qIndex].status = currentAttempts.length > 0 ? "answered" : "skip";
    }

    this.setState({ questions: updatedQuestions }, () => {
      this.autoSaveProgress();
      this.syncQuestionProgress(qIndex);
    });
  };

  /**
   * Text Input for Integer/Numeric types (qtype 8)
   */
  handleTextInput = (question_id, value) => {
    const { questions } = this.state;
    const qIndex = questions.findIndex((q) => q.id === question_id);
    if (qIndex === -1) return;

    const updatedQuestions = [...questions];
    const q = updatedQuestions[qIndex];

    // Restrict qtype 8 to numeric input and dots only
    if (q.qtype == 8 || q.qtype == "8") {
      value = value.replace(/[^0-9.-]/g, '');
    }

    if (!value || !value.trim()) {
      updatedQuestions[qIndex].attempted = null;
      if (updatedQuestions[qIndex].status !== "review") {
        updatedQuestions[qIndex].status = "skip";
      }
    } else {
      updatedQuestions[qIndex].attempted = value;
      if (updatedQuestions[qIndex].status !== "review") {
        updatedQuestions[qIndex].status = "answered";
      }
    }
    this.setState({ questions: updatedQuestions }, () => {
      this.autoSaveProgress();
      this.syncQuestionProgress(qIndex);
    });
  };

  /**
   * Sync a single question's progress to the database
   */
  syncQuestionProgress = async (index) => {
    const { questions, dbSession } = this.state;
    const q = questions[index];
    if (!dbSession || !dbSession.id) return;

    try {
      await this.props.client.mutate({
        mutation: SYNC_ADMISSION_SESSION_QUESTION,
        variables: {
          admission_test_session_id: parseInt(dbSession.id),
          question_id: parseInt(q.id),
          attempt_answer: q.attempted || "",
          question_time: parseInt(q.timer) || 0,
          status: q.status === "answered" ? 1 : q.status === "review" ? 2 : q.status === "skip" ? 3 : 0
        }
      });
    } catch (e) {
      console.error("Failed to sync question progress", e);
    }
  };

  // ─── FETCH QUESTIONS ──────────────────────────────────────────────────────
  fetchQuestions = async (dbSessionId = null) => {
    const { session } = this.state;
    const admission_test_id =
      session?.admission_test_id ||
      this.props.location?.state?.admission_test_id;
    if (!admission_test_id) {
      this.setState({
        loadingQuestions: false,
        loadError: "No admission test ID found. Please login again.",
      });
      return;
    }
    try {
      const result = await this.props.client.query({
        query: GET_ADMISSION_TEST_QUESTIONS,
        variables: { admission_test_id: parseInt(admission_test_id) },
        fetchPolicy: "network-only",
      });

      let examDurationMin = 180;
      let examSections = [];
      try {
        const patternResult = await this.props.client.query({
          query: GET_ADMISSION_TEST_PATTERN,
          variables: { admission_test_id: parseInt(admission_test_id) },
          fetchPolicy: "network-only",
        });
        const patternData = patternResult.data.getAdmissionTestPattern;
        if (patternData) {
          if (patternData.duration) examDurationMin = parseInt(patternData.duration);
          if (patternData.sections) examSections = patternData.sections;
        }
      } catch (err) {
        console.warn("Failed to fetch pattern", err);
      }
      const rawQuestions = result.data.getAdmissionTestQuestions || [];
      if (rawQuestions.length === 0) {
        this.setState({
          loadingQuestions: false,
          loadError: "No questions found for this test.",
        });
        return;
      }

      // ── AUTO-SAVE RESTORATION ──
      const storageKey = `admissionAutoSave_${admission_test_id}_${session?.enquiry_form_master_id}`;
      const savedData = localStorage.getItem(storageKey);
      let autoAnswers = {};
      let restoredIndex = 0;
      let restoredTimeLeft = this.state.timeLeft || (examDurationMin * 60);
      if (savedData) {
        try {
          const parsed = JSON.parse(savedData);
          if (parsed.answers) autoAnswers = parsed.answers;
          if (parsed.qsno !== undefined) restoredIndex = parseInt(parsed.qsno);
        } catch (e) { }
      }

      // Map subject names and initially sort by subject IDs (1 -> 2 -> 3 -> 4)
      const mappedQuestions = rawQuestions.map(q => {
        const prev = autoAnswers[q.id] || {}; // Restore previous state if available
        return {
          ...q,
          subject_name: SUBJECT_MAP[q.subject] || q.subject,
          raw_question: q.question, // Save the raw question to safely parse JSON
          question: decodeURIComponent(q.question || ""),
          option1: decodeURIComponent(q.option1 || ""),
          option2: decodeURIComponent(q.option2 || ""),
          option3: decodeURIComponent(q.option3 || ""),
          option4: decodeURIComponent(q.option4 || ""),
          option5: decodeURIComponent(q.option5 || ""),
          compquestion: decodeURIComponent(q.compquestion || ""),
          mat_question: decodeURIComponent(q.mat_question || ""),
          mat_que_paragraph: decodeURIComponent(q.mat_que_paragraph || ""),
          mat_que_footer: decodeURIComponent(q.mat_que_footer || ""),
          explanation: decodeURIComponent(q.explanation || ""),
          no_of_marks: q.no_of_marks || 4,
          no_of_neg_marks: q.no_of_neg_marks || 1,
          attempted: prev.attempted !== undefined ? prev.attempted : null,
          // result field is removed for security
          timer: prev.timer || 0,
          status: prev.status || "",
          reason: prev.reason || 0,
          comments: prev.comments || "",
          isSubmitted: prev.isSubmitted || false,
          lastindex: prev.lastindex || "",
          reasonstatus: prev.reasonstatus || "0",
          sidebutton: prev.sidebutton || "1",
        };
      });

      // Sort questions sequentially by subject so navigation is smooth
      let questions = mappedQuestions.sort((a, b) => a.subject - b.subject);

      // Assign a reliable computed global number based on sorted order
      questions.forEach((q, i) => {
        q.computed_global_no = i + 1;
      });

      // ── DB SESSION DATA MERGING ──
      if (dbSessionId) {
        try {
          const sessionRes = await this.props.client.query({
            query: GET_ADMISSION_SESSION_QUESTIONS,
            variables: { admission_test_session_id: parseInt(dbSessionId) },
            fetchPolicy: 'network-only'
          });
          const rawSessionQs = sessionRes.data.getAdmissionSessionQuestions || [];
          // Deduplicate by question_id to handle any database anomalies
          const seen = new Set();
          const sessionQs = rawSessionQs.filter(sq => {
            if (seen.has(sq.question_id)) return false;
            seen.add(sq.question_id);
            return true;
          });

          sessionQs.forEach(sq => {
            const q = questions.find(x => parseInt(x.id) === parseInt(sq.question_id));
            if (q) {
              q.attempted = sq.attempt_answer || null;
              q.timer = sq.question_time || 0;
              q.status = sq.status === 1 ? "answered" : sq.status === 2 ? "review" : sq.status === 3 ? "skip" : "";
            }
          });
        } catch (e) {
          console.error("Failed to merge DB session data", e);
        }
      }

      // ── SECTION SPLITTING: per subject ──
      // Group questions by subject, preserving order
      const subjectGroups = {};
      questions.forEach((q) => {
        const sid = q.subject;
        if (!subjectGroups[sid]) subjectGroups[sid] = [];
        subjectGroups[sid].push(q);
      });

      // Reconstruct questions array with section tags mapped from pattern limits
      let fullyMappedQuestions = [];
      Object.keys(subjectGroups).forEach((sid) => {
        const subQs = subjectGroups[sid];

        // Find pattern rules for this specific subject
        const subSections = examSections.filter(
          (s) => String(s.subject_id) === String(sid)
        );

        if (subSections.length > 0) {
          // We have explicit sections from the pattern for this subject
          // Sort sections by starting_no to map sequentially
          subSections.sort((a, b) => parseInt(a.starting_no) - parseInt(b.starting_no));

          subQs.forEach(q => {
            // Priority 1: Check if the question falls within a global range (starting_no to ending_no) if they seem to refer to global numbers.
            // Since the API sends starting_no across subjects without resetting, we use `computed_global_no`.
            const matchingSectionByGlobal = subSections.find(s =>
              q.computed_global_no >= parseInt(s.starting_no) && q.computed_global_no <= parseInt(s.ending_no)
            );

            if (matchingSectionByGlobal) {
              q.section_name = matchingSectionByGlobal.section_name;
              q.section_rules = matchingSectionByGlobal;

              // Inherit marks from section if not explicitly set on question
              if (matchingSectionByGlobal.no_of_marks) q.no_of_marks = matchingSectionByGlobal.no_of_marks;
              if (matchingSectionByGlobal.no_of_neg_marks) q.no_of_neg_marks = matchingSectionByGlobal.no_of_neg_marks;
            } else {
              // Fallback if bounds mismatch
              q.section_name = subSections[0].section_name;
              q.section_rules = subSections[0];
            }
          });
        } else {
          // Fallback logical split per subject using qtype=8 (Match/Fill)
          let currentSection = "Section A";
          let foundType8 = false;

          subQs.forEach((q) => {
            // Change section when we hit the first question of type 8 in this subject
            if ((q.qtype === "8" || q.qtype === 8) && !foundType8) {
              currentSection = "Section B";
              foundType8 = true;
            }
            q.section_name = currentSection;
          });
        }

        fullyMappedQuestions = fullyMappedQuestions.concat(subQs);
      });

      questions = fullyMappedQuestions;

      const uniqueSubjects = [...new Set(questions.map(q => q.subject_name))];
      this.setState({
        questions,
        activeSubject:
          questions[restoredIndex]?.subject_name || uniqueSubjects[0] || "",
        currentIndex: restoredIndex,
        timeLeft: restoredTimeLeft,
        loadingQuestions: false,
      });
    } catch (err) {
      console.error("Failed to load admission test questions:", err);
      this.setState({
        loadingQuestions: false,
        loadError:
          err.message?.replace("GraphQL error: ", "") ||
          "Failed to load questions. Please try again.",
      });
    }
  };

  componentWillUnmount() {
    clearInterval(this.timer);
    clearInterval(this.autoSaveTimer);
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
    window.removeEventListener("contextmenu", () => { });
    window.removeEventListener("selectstart", () => { });
    window.removeEventListener("keypress", () => { });
    window.removeEventListener("beforeunload", this.handleWindowBeforeUnload);
  }

  handleWindowBeforeUnload = () => {
    // Save exam state when page is about to unload
    this.autoSaveProgress();
  };

  updateOnlineStatus = () => this.setState({ isOnline: navigator.onLine });

  startExam = () => {
    this.setState({ showInstructions: false, examStarted: true });

    // Single 1-second Heartbeat for all timing logic
    this.timer = setInterval(() => {
      const { timeLeft, submitStatus, questions, currentIndex } = this.state;
      if (submitStatus !== 1) return;

      const newState = {};

      // 1. Global Countdown
      if (timeLeft > 0) {
        const newTime = timeLeft - 1;
        newState.timeLeft = newTime;
        newState.timeWarning = newTime < 120;
      } else {
        this.submitExam();
        return;
      }

      // 2. Per-Question Spent Time tracking
      if (questions && questions[currentIndex]) {
        const arr = [...questions];
        arr[currentIndex].timer = (arr[currentIndex].timer || 0) + 1;
        newState.questions = arr;
      }

      this.setState(newState);
    }, 1000);

    // Regular DB Sync and Auto-save
    this.autoSaveTimer = setInterval(() => this.autoSaveProgress(), 25000);
    this.autoSaveProgress();
  };

  // ─── AUTO SAVE (OPTIMIZED) ────────────────────────────────────────────────────
  autoSaveProgress = () => {
    const { questions, currentIndex, timeLeft, session } = this.state;
    if (questions.length === 0) return;

    // Create a lightweight answers map (only save answer data, not question text)
    const answers = {};
    questions.forEach((q) => {
      if (q.attempted || q.timer || q.status) {
        answers[q.id] = {
          a: q.attempted,
          t: q.timer,
          s: q.status
        };
      }
    });

    const storageKey = `admissionAutoSave_${session?.admission_test_id}_${session?.enquiry_form_master_id}`;
    localStorage.setItem(
      storageKey,
      JSON.stringify({
        qsno: currentIndex,
        examtimer: timeLeft,
        answers: answers,
      }),
    );
    localStorage.setItem("resumeExam", "true");

    // NEW: Sync current question time to DB periodically
    this.syncQuestionProgress(currentIndex);
  };

  formatTime = (s) => {
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}:${sec.toString().padStart(2, "0")}`;
  };

  // ─── ANSWER SELECTION ──────────────────────────────────────────────────────
  // ... methods used in renderExam

  clearOption = () => {
    const questions = [...this.state.questions];
    const idx = this.state.currentIndex;
    questions[idx].attempted = null;
    questions[idx].result = "";
    questions[idx].status = "";
    this.setState({ questions }, () => {
      this.autoSaveProgress();
      this.syncQuestionProgress(idx);
    });
  };

  // ─── MARK FOR REVIEW ───────────────────────────────────────────────────────
  toggleReview = () => {
    const questions = [...this.state.questions];
    const idx = this.state.currentIndex;
    const q = questions[idx];

    if (q.status === "review") {
      // Removing review: check if it's answered or just visited
      questions[idx].status = q.attempted ? "answered" : "skip";
    } else {
      // Setting to review
      questions[idx].status = "review";
    }

    this.setState({ questions }, () => {
      this.autoSaveProgress();
      this.syncQuestionProgress(idx);
    });
  };

  // ─── NAVIGATION ────────────────────────────────────────────────────────────
  sideQFun = (index) => {
    const arr = [...this.state.questions];
    const idata = arr[index];
    if (index === this.state.currentIndex) return;

    if (idata.status === '') {
      if (arr[this.state.currentIndex].status === '') {
        const prevIdx = this.state.currentIndex;
        arr[prevIdx].status = 'skip';
        this.setState({ questions: arr, currentIndex: index }, () => {
          this.syncActiveSubject(index);
          this.syncQuestionProgress(prevIdx);
          this.autoSaveProgress();
        });
      } else {
        this.setState({ currentIndex: index }, () => {
          this.syncActiveSubject(index);
          this.autoSaveProgress();
        });
      }
    } else {
      if (idata.status === "skip") {
        arr[index].status = "";
      }
      this.setState({ questions: arr, currentIndex: index }, () => {
        this.syncActiveSubject(index);
        this.autoSaveProgress();
      });
    }
  };

  syncActiveSubject = (index) => {
    this.setState({ activeSubject: this.state.questions[index].subject_name });
  };

  handleNext = () => {
    const { currentIndex, questions } = this.state;
    const arr = [...questions];
    const prevIdx = currentIndex;

    if (arr[currentIndex].status === '') {
      arr[currentIndex].status = 'skip';
    }

    if (currentIndex < questions.length - 1) {
      const nextIdx = currentIndex + 1;
      this.setState({ questions: arr, currentIndex: nextIdx }, () => {
        this.syncActiveSubject(nextIdx);
        this.syncQuestionProgress(prevIdx);
        this.autoSaveProgress();
      });
    } else {
      this.setState({ questions: arr }, () => {
        this.syncQuestionProgress(prevIdx);
        this.autoSaveProgress();
      });
    }
  };

  handlePrev = () => {
    if (this.state.currentIndex > 0) {
      const targetIdx = this.state.currentIndex - 1;
      this.setState({ currentIndex: targetIdx }, () => {
        this.syncActiveSubject(targetIdx);
        this.autoSaveProgress();
      });
    }
  };

  handleSubmit = () => this.setState({ showConfirm: true });

  // ─── PDF GENERATION ──────────────────────────────────────────────────────
  generatePdfBase64 = async () => {
    // We need jspdf and html2canvas. They are likely available on window or can be imported.
    // Based on package.json, jspdf is installed. react-to-pdf uses html2canvas.
    const html2canvas = require("html2canvas");
    const { jsPDF } = require("jspdf");

    const element = this.pdfRef.current;
    if (!element) return null;

    try {
      const canvas = await html2canvas(element, {
        scale: 2, // Higher quality
        useCORS: true,
        logging: false,
      });
      const imgData = canvas.toDataURL("image/jpeg", 0.7);
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
      return pdf.output("datauristring");
    } catch (e) {
      console.error("PDF Generation Error:", e);
      return null;
    }
  };

  // ─── SUBMIT EXAM ───────────────────────────────────────────────────────────
  submitExam = async () => {
    const { questions, session, submitting } = this.state;
    if (submitting) return;

    this.setState({ submitting: true });
    clearInterval(this.timer);
    clearInterval(this.autoSaveTimer);
    stopExamStatus = "1";

    const attempts = questions.map((q) => ({
      question_id: parseInt(q.id),
      attempt_answer: q.attempted || "",
      time_spent: parseInt(q.timer) || 0,
    }));

    try {
      // --- STAGE 1: SUBMIT ANSWERS & GET RESULTS ---
      const response = await this.props.client.mutate({
        mutation: SUBMIT_ADMISSION_TEST_SESSION,
        variables: {
          enquiry_form_master_id: parseInt(session?.enquiry_form_master_id),
          admission_test_id: parseInt(session?.admission_test_id),
          attempts: attempts,
          is_completed: 1,
        },
      });

      const resultData = response.data.submitAdmissionTestSession;

      // --- STAGE 2: GENERATE PDF ---
      this.setState({
        isGeneratingPdf: true,
        resultDataForPdf: resultData,
      });

      // Wait a small bit for the hidden component to render
      await new Promise((resolve) => setTimeout(resolve, 500));

      const pdfBase64 = await this.generatePdfBase64();

      if (pdfBase64) {
        // --- STAGE 3: UPLOAD PDF ---
        try {
          await this.props.client.mutate({
            mutation: SUBMIT_ADMISSION_TEST_SESSION,
            variables: {
              enquiry_form_master_id: parseInt(session?.enquiry_form_master_id),
              admission_test_id: parseInt(session?.admission_test_id),
              attempts: attempts,
              is_completed: 1,
              pdf_base64: pdfBase64,
              filename: `Result_${session?.student_name || "Student"}.pdf`,
            },
          });
        } catch (uploadErr) {
          console.error("PDF Upload Error:", uploadErr);
          // We continue even if upload fails so user can see result
        }
      }

      localStorage.removeItem("resumeExam");
      const storageKey = `admissionAutoSave_${session?.admission_test_id}_${session?.enquiry_form_master_id}`;
      localStorage.removeItem(storageKey);

      this.props.history.push({
        pathname: "/admission-test-result",
        state: {
          correct: resultData.correct,
          wrong: resultData.wrong,
          total_marks_gained: resultData.total_marks_gained,
          total_marks: resultData.total_marks,
          total_questions: questions.length,
          subject_analytics: resultData.subject_analytics,
          student_name: session?.student_name || session?.username || "Student",
          branch_name: session?.branch_name || session?.branch || "",
          course_name: session?.course_name || session?.course || "",
        },
      });
    } catch (err) {
      this.setState({ submitting: false, isGeneratingPdf: false });
      console.error("submitAdmissionTestSession error:", err);
      alert(
        "Failed to submit exam. Please check your connection and try again.",
      );
    }
  };

  // ─── RENDER: INSTRUCTIONS ──────────────────────────────────────────────────
  renderInstructions() {
    const { examConfig, questions } = this.state;
    const session = this.props.location?.state;

    // Group counts dynamically
    const subjectCounts = {};
    questions.forEach(q => {
      subjectCounts[q.subject_name] = (subjectCounts[q.subject_name] || 0) + 1;
    });

    return (
      <div className="sudent_exam_block">
        <div className="at-header">
          <h6>
            <img
              src={RizeeLogo}
              alt="Rizee"
              style={{ height: 28, marginRight: 8, verticalAlign: "middle" }}
            />
            Admission Test
          </h6>
        </div>
        <div className="container py-4" style={{ maxWidth: 700 }}>
          <div className="card">
            <div
              className="card-header"
              style={{ background: "#f8fafc", padding: "10px 16px" }}
            >
              <h6
                className="mb-0"
                style={{ fontWeight: 700, color: "#0f172a", fontSize: 14 }}
              >
                📋 Read Before Starting
              </h6>
            </div>
            <div className="card-body p-0">
              {/* Student info strip */}
              <div className="px-3 pt-3 pb-2">
                <div
                  className="d-flex align-items-center mb-3"
                  style={{ gap: 12 }}
                >
                  <div
                    style={{
                      width: 46,
                      height: 46,
                      borderRadius: "50%",
                      background: "linear-gradient(90deg,#60a5fa,#3b82f6)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      fontSize: 20,
                    }}
                  >
                    🎓
                  </div>
                  <div>
                    <h6 className="mb-0" style={{ fontWeight: 700 }}>
                      {session?.student_name || "Student"}
                    </h6>
                    <p
                      className="mb-0"
                      style={{ fontSize: 12, color: "#64748b" }}
                    >
                      {session?.admission_test || "Admission Test"}
                    </p>
                  </div>
                  <div className="ml-auto d-flex" style={{ gap: 16 }}>
                    {[
                      { val: this.state.questions.length, label: "Questions" },
                      { val: examConfig.exam_duration_min, label: "Mins" },
                    ].map((item, i) => (
                      <div
                        key={i}
                        className="text-center"
                        style={{
                          borderLeft: "1px solid #e2e8f0",
                          paddingLeft: 12,
                        }}
                      >
                        <div style={{ fontWeight: 700, fontSize: 16 }}>
                          {item.val}
                        </div>
                        <div style={{ fontSize: 11, color: "#64748b" }}>
                          {item.label}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <hr style={{ margin: "0 16px" }} />

              {/* Subject Breakdown */}
              {Object.keys(subjectCounts).length > 0 && (
                <div className="px-3 pt-3 pb-2">
                  <p
                    style={{
                      fontSize: 12,
                      color: "#64748b",
                      fontWeight: 600,
                      marginBottom: 8,
                    }}
                  >
                    SUBJECT BREAKDOWN
                  </p>
                  <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                    {Object.entries(subjectCounts).map(
                      ([subjectName, count], idx) => (
                        <span
                          key={idx}
                          style={{
                            background: "#dbeafe",
                            color: "#3b82f6",
                            padding: "6px 12px",
                            borderRadius: 20,
                            fontSize: 13,
                            fontWeight: 600,
                          }}
                        >
                          {subjectName}: {count} Questions
                        </span>
                      ),
                    )}
                  </div>
                </div>
              )}

              {/* Instructions list */}
              <div className="px-3 py-2">
                {[
                  {
                    icon: "🔒",
                    text: "Do not refresh or close the browser during the exam",
                  },
                  {
                    icon: "🚫",
                    text: "Once submitted, the exam cannot be retaken",
                  },
                  {
                    icon: "🔢",
                    text: "Use the Question Palette to navigate through questions",
                  },
                  {
                    icon: "🔖",
                    text: "Mark questions for review to revisit them before final submission",
                  },
                  {
                    icon: "⏱",
                    text: "The exam will automatically submit once the time expires",
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="d-flex align-items-center mb-2"
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                      borderRadius: 5,
                      padding: "10px 14px",
                      gap: 12,
                    }}
                  >
                    <span style={{ fontSize: 18, flexShrink: 0 }}>
                      {item.icon}
                    </span>
                    <span style={{ fontSize: 13, color: "#475569" }}>
                      {item.text}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <div
              className="card-footer text-center"
              style={{ background: "#fff", padding: 16 }}
            >
              <button
                className="btn btn-lg w-100"
                style={{
                  fontSize: 13,
                  borderRadius: 25,
                  background: "#10b981",
                  color: "#fff",
                  border: "none",
                  fontWeight: 600,
                }}
                onClick={this.startExam}
              >
                ✅ I Understand, Start Exam
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  parseFun(str) {
    if (!str) return false;
    return <span dangerouslySetInnerHTML={{ __html: str }} />;
  }

  renderQuestionContent(q) {
    if (!q) return null;

    // Support for Comprehension / Paragraph based questions (qtype 5)
    const comprehensionPart = (q.qtype == 5 && q.compquestion) ? (
      <div className="at-comp-question mb-3 p-3" style={{ background: '#f1f5f9', borderRadius: 8, borderLeft: '4px solid #3b82f6' }}>
        <div className="at-comp-text text-justify" style={{ fontSize: 15, color: '#334155', lineHeight: 1.6 }}>
          {this.parseFun(q.compquestion)}
        </div>
      </div>
    ) : null;

    // Support for Matrix Match / List type questions (qtype 3, 9)
    let matrixPart = null;
    if (q.qtype == 3 || q.qtype == 9) {
      const matQText = (q.mat_question && q.mat_question !== "undefined") ? q.mat_question : null;
      try {
        let parsed = null;
        if (q.raw_question && typeof q.raw_question === 'string') {
          try {
            // Re-parsing carefully to avoid double-decoding issues
            parsed = JSON.parse(q.raw_question);
          } catch (e) { }
        }

        if (matQText || (Array.isArray(parsed) && parsed.length > 0)) {
          matrixPart = (
            <div className="at-matrix-block my-3">
              {matQText && matQText !== q.question && <div className="mb-3">{this.parseFun(matQText)}</div>}
              {q.mat_que_paragraph && q.mat_que_paragraph !== "undefined" && <div className="mb-3 text-justify">{this.parseFun(q.mat_que_paragraph)}</div>}

              <div className="row match-the-following">
                <div className="col-md-6 col-sm-12 my-2">
                  <h6 className="font-weight-bold mb-2" style={{ color: '#0f172a' }}>List I</h6>
                  <ol className="ml-3 p-0" type={q.list1type === "numbers" ? "1" : q.list1type === "alphabets" ? "A" : "I"}
                    style={{ listStyleType: q.list1type === "numbers" ? 'decimal' : q.list1type === "alphabets" ? 'upper-alpha' : 'upper-roman' }}>
                    {Array.isArray(parsed) && parsed.map((item, i) => (
                      <li key={`l1-${i}`} className="mb-2">
                        {this.parseFun(decodeURIComponent(item.qlist1 || ""))}
                      </li>
                    ))}
                  </ol>
                </div>
                <div className="col-md-6 col-sm-12 my-2">
                  <h6 className="font-weight-bold mb-2" style={{ color: '#0f172a' }}>List II</h6>
                  <ol className="ml-3 p-0" type={q.list2type === "numbers" ? "1" : q.list2type === "alphabets" ? "A" : "I"}
                    style={{ listStyleType: q.list2type === "numbers" ? 'decimal' : q.list2type === "alphabets" ? 'upper-alpha' : 'upper-roman' }}>
                    {Array.isArray(parsed) && parsed.map((item, i) => (
                      <li key={`l2-${i}`} className="mb-2">
                        {this.parseFun(decodeURIComponent(item.qlist2 || ""))}
                      </li>
                    ))}
                  </ol>
                </div>
              </div>
              {q.mat_que_footer && q.mat_que_footer !== "undefined" && <div className="mt-3 small text-muted">{this.parseFun(q.mat_que_footer)}</div>}
            </div>
          );
        }
      } catch (e) {
        console.warn("Failed to render matrix part:", e);
      }
    }

    return (
      <React.Fragment>
        {comprehensionPart}
        <div className="at-main-question">
          {matrixPart ? matrixPart : this.parseFun(q.question)}
        </div>
      </React.Fragment>
    );
  }

  // ─── RENDER: EXAM ──────────────────────────────────────────────────────────
  renderExam() {
    const {
      questions,
      currentIndex,
      timeLeft,
      timeWarning,
      showConfirm,
      activeSubject,
    } = this.state;

    const q = questions[currentIndex];
    const session = this.props.location?.state;
    const answeredCount = questions.filter(
      (x) => x.status === "answered"
    ).length;
    const skippedCount = questions.filter((x) => x.status === "skip").length;
    const reviewCount = questions.filter((x) => x.status === "review").length;
    const notVisited = questions.filter((x) => x.status === "").length;
    const progress = Math.round(((currentIndex + 1) / questions.length) * 100);
    const uniqueSubjects = [...new Set(questions.map(q => q.subject_name))];

    return (
      <React.Fragment>
        <div className="exam_test">
          {/* Offline Banner */}
          {!this.state.isOnline && (
            <div className="at-offline-banner">
              <i className="fas fa-wifi-slash mr-2" />
              Offline Mode — Progress saved locally. Will sync when back online.
            </div>
          )}

          {/* ── NAVBAR ── */}
          <div className="exam-navbar d-flex align-items-center justify-content-between px-4 py-2">
            <div className="exam-logo">
              <img
                src={RizeeLogo}
                alt="Rizee"
                style={{ height: 26, marginRight: 8, verticalAlign: "middle" }}
              />
              Admission Test
            </div>
            <div className={`exam-timer${timeWarning ? " text-danger" : ""}`}>
              <i className="fal fa-clock mr-2" />
              {this.formatTime(timeLeft)}
              {timeWarning && (
                <span className="exam-timer__warn"> ⚠ Time running out!</span>
              )}
            </div>
            <button
              className="btn btn-danger exam-navbar__submit"
              onClick={this.handleSubmit}
            >
              Submit Exam
            </button>
          </div>

          {/* ── PROGRESS BAR ── */}
          <div className="progress" style={{ height: 4, borderRadius: 0 }}>
            <div
              className="progress-bar"
              style={{
                width: `${progress}%`,
                background: timeWarning ? "#ef4444" : "#10b981",
                transition: "width 0.3s",
              }}
            />
          </div>

          {/* ── BODY ── */}
          <div className="exam-body">
            {/* ════════ LEFT SIDEBAR ════════ */}
            <div className="exam-sidebar">
              {/* Candidate strip */}
              <div className="sidebar-candidate">
                <div className="sidebar-candidate__avatar">👤</div>
                <div className="sidebar-candidate__info">
                  <p className="sidebar-candidate__greeting">GOOD LUCK! 🎯</p>
                  <h6 className="sidebar-candidate__name">{session?.student_name || session?.username || 'Student'}</h6>
                  <p className="sidebar-candidate__exam">{session?.admission_test || 'Admission Test'}</p>
                </div>
              </div>

              {/* Scrollable body */}
              <div className="sidebar-body">
                {/* ── SUBJECT TABS — top level ── */}
                <div className="sidebar-subject-tabs">
                  {uniqueSubjects.map((subject, i) => (
                    <button
                      key={i}
                      className={`btn btn-sm ${activeSubject === String(subject) ? 'btn-primary' : 'btn-outline-primary'}`}
                      style={{ borderRadius: 20, minWidth: 80 }}
                      onClick={() => {
                        const firstQ = questions.findIndex(x => x.subject_name === subject);
                        if (firstQ !== -1) this.setState({ currentIndex: firstQ, activeSubject: subject });
                      }}
                    >
                      {subject}
                    </button>
                  ))}
                </div>

                {/* ── SECTION GROUPS inside active subject ── */}
                {[...new Set(
                  questions
                    .filter(q => q.subject_name === activeSubject)
                    .map(q => q.section_name)
                )].map((sectionName, si) => {
                  const sectionQs = questions.filter(
                    q => q.subject_name === activeSubject && q.section_name === sectionName
                  );
                  const doneCount = sectionQs.filter(
                    (q) => q.status === "answered",
                  ).length;

                  return (
                    <div key={si} className="sidebar-section-group">
                      <div className="sidebar-section-header">
                        <span className="sidebar-section-header__name">
                          {sectionName}
                        </span>
                        <span className="sidebar-section-header__count">
                          {doneCount}/{sectionQs.length}
                        </span>
                      </div>
                      <div className="question-palette">
                        {sectionQs.map((item) => {
                          const globalIdx = questions.findIndex(
                            (q) => q.id === item.id,
                          );
                          let cls = "palette-btn";
                          if (globalIdx === currentIndex) cls += " active";
                          else if (item.status === "review") cls += " review";
                          else if (
                            item.status === "answered"
                          )
                            cls += " answered";
                          else if (item.status === "skip") cls += " skipped";
                          return (
                            <button
                              key={item.id}
                              className={cls}
                              onClick={() => this.sideQFun(globalIdx)}
                            >
                              {globalIdx + 1}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}

                {/* ── STATS — attractive 2×2 grid ── */}
                <div className="sidebar-stats-grid">
                  {[
                    {
                      label: "Answered",
                      value: answeredCount,
                      icon: "✅",
                      cls: "stat--green",
                    },
                    {
                      label: "Skipped",
                      value: skippedCount,
                      icon: "⏭",
                      cls: "stat--yellow",
                    },
                    {
                      label: "Review",
                      value: reviewCount,
                      icon: "🔖",
                      cls: "stat--purple",
                    },
                    {
                      label: "Pending",
                      value: notVisited,
                      icon: "⭕",
                      cls: "stat--grey",
                    },
                  ].map((item, i) => (
                    <div key={i} className={`stat-card ${item.cls}`}>
                      <span className="stat-card__icon">{item.icon}</span>
                      <span className="stat-card__value">{item.value}</span>
                      <span className="stat-card__label">{item.label}</span>
                    </div>
                  ))}
                </div>
              </div>
              {/* end .sidebar-body */}
            </div>
            {/* end .exam-sidebar */}

            {/* ════════ RIGHT — QUESTION AREA ════════ */}
            <div className="exam-content">
              <div key={currentIndex} className="question-card p-4">
                {/* Question header */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span className="question-header__counter">
                    Question <strong>{currentIndex + 1}</strong> of{" "}
                    {questions.length}
                  </span>
                  <div className="d-flex align-items-center" style={{ gap: 8 }}>
                    {/* ── MARK FOR REVIEW BUTTON ── */}
                    <button
                      className={`exam-review-btn${q.status === "review" ? " active" : ""}`}
                      onClick={this.toggleReview}
                    >
                      {q.status === "review"
                        ? "🔖 Marked"
                        : "🔖 Mark for Review"}
                    </button>
                    {/* <span className="question-header__subject-tag">
                      {q.subject}
                    </span> */}
                  </div>
                </div>

                {/* Section › Subject breadcrumb */}
                <div className="d-flex align-items-center mb-3" style={{ gap: 6 }}>
                  <span className="at-section-badge">{q.section_name || 'Standard Exam'}</span>
                  <span style={{ color: '#94a3b8' }}>›</span>
                  <span className="at-subject-badge">{q.subject_name || q.subject}</span>
                </div>

                {/* Question text */}
                <div className="question_block mb-4">
                  <div className="question-text">
                    {this.renderQuestionContent(q)}
                  </div>
                </div>

                {/* Options */}
                <div className="question_options">
                  {q.qtype == 8 || q.qtype == "8" ? (
                    <div className="card mt-3">
                      <div className="card-body py-4 px-4">
                        <h6 className="mb-3" style={{ color: '#0f172a', fontWeight: 'bold' }}>Enter your answer:</h6>
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          value={q.attempted || ''}
                          onChange={(e) => this.handleTextInput(q.id, e.target.value)}
                          onPaste={(e) => e.preventDefault()}
                          placeholder="Type your numeric answer here..."
                          maxLength={10}
                          style={{ border: '2px solid #e2e8f0', borderRadius: '8px', fontSize: '16px' }}
                        />
                      </div>
                    </div>
                  ) : (
                    (() => {
                      const availOptions = [];
                      if (q.option1) availOptions.push({ key: 'option1', label: 'A', value: q.option1 });
                      if (q.option2) availOptions.push({ key: 'option2', label: 'B', value: q.option2 });
                      if (q.option3) availOptions.push({ key: 'option3', label: 'C', value: q.option3 });
                      if (q.option4) availOptions.push({ key: 'option4', label: 'D', value: q.option4 });
                      if (q.option5) availOptions.push({ key: 'option5', label: 'E', value: q.option5 });

                      // Determine if MSQ
                      const isMulti = q.qtype == 2 || q.qtype == "2";
                      const currentAttempt = (q.attempted || "").replace(/,$/, "");
                      const attemptsList = isMulti ? currentAttempt.split(",") : [currentAttempt];

                      return availOptions.map((opt, i) => {
                        // Check if attempted string contains the label followed by a comma
                        const isSelected = attemptsList.includes(opt.label);
                        return (
                          <div
                            key={i}
                            className={`single_card${isSelected ? ' active' : ''}`}
                            onClick={() => isMulti ? this.selectOptionMulti(q.id, opt.label) : this.selectOption(q.id, opt.label)}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="card mb-2" style={{
                              transition: 'border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease'
                            }}>
                              <div className="card-body py-3 px-3 d-flex align-items-center">
                                <div className="at-exam-grid-container">
                                  <span className="option_No">
                                    {opt.label}
                                  </span>
                                  <div className="option-content-container">
                                    {this.parseFun(opt.value)}
                                  </div>
                                  <div className="option-check-container">
                                    {isSelected && (
                                      <i className={`fas fa-${isMulti ? 'check-square' : 'check-circle'}`} style={{ color: '#10b981', fontSize: '18px' }} />
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      });
                    })()
                  )}
                </div>

                {/* Navigation */}
                <div className="exam-nav d-flex justify-content-between align-items-center mt-4 pt-3">
                  <button
                    className="btn btn-outline-secondary"
                    disabled={currentIndex === 0}
                    onClick={this.handlePrev}
                  >
                    ← Previous
                  </button>
                  <button
                    className="btn btn-link at-clear-btn"
                    onClick={this.clearOption}
                  >
                    Clear Response
                  </button>
                  {currentIndex < questions.length - 1 ? (
                    <button
                      className="btn exam-nav__btn-next"
                      onClick={this.handleNext}
                    >
                      Next →
                    </button>
                  ) : (
                    <button
                      className="btn exam-nav__btn-submit"
                      onClick={this.handleSubmit}
                    >
                      ✅ Submit
                    </button>
                  )}
                </div>
              </div>
            </div>
            {/* end .exam-content */}
          </div>
          {/* end .exam-body */}
        </div>
        {/* end .exam_test */}

        {/* ── CONFIRM SUBMIT MODAL ── */}
        <Modal
          show={showConfirm}
          onHide={() => this.setState({ showConfirm: false })}
          centered
          size="sm"
        >
          <Modal.Header>
            <Modal.Title>✅ Submit Exam</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <table className="table table-borderless mb-0">
              <tbody>
                {[
                  {
                    label: "Answered",
                    value: answeredCount,
                    cls: "val--green",
                  },
                  { label: "Skipped", value: skippedCount, cls: "val--yellow" },
                  {
                    label: "Marked Review",
                    value: reviewCount,
                    cls: "val--purple",
                  },
                  { label: "Pending", value: notVisited, cls: "val--grey" },
                ].map((row, i) => (
                  <tr key={i}>
                    <td className="at-modal__stats-label">{row.label}</td>
                    <td className={`at-modal__stats-value ${row.cls}`}>
                      {row.value}
                    </td>
                  </tr>
                ))}
                <tr style={{ borderTop: "1px solid #e2e8f0" }}>
                  <td className="at-modal__stats-label">Time Remaining</td>
                  <td
                    className={`at-modal__stats-value ${timeWarning ? "val--danger" : "val--dark"}`}
                  >
                    {this.formatTime(timeLeft)}
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="at-modal__confirm-text mt-3">
              Are you sure you want to submit?
              <br />
              <strong>You cannot retake this exam.</strong>
            </p>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="at-modal__btn-cancel"
              onClick={() => this.setState({ showConfirm: false })}
            >
              Cancel
            </button>
            <button 
              className="at-modal__btn-login" 
              onClick={this.submitExam}
              disabled={this.state.submitting}
            >
              {this.state.isGeneratingPdf ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-2" />
                  Finalizing Report...
                </>
              ) : this.state.submitting ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-2" />
                  Submitting...
                </>
              ) : (
                <>✅ Yes, Submit</>
              )}
            </button>
          </Modal.Footer>
        </Modal>

        {/* ── HIDDEN PDF RENDERER ── */}
        <div 
          style={{ 
            position: 'absolute', 
            left: '-9999px', 
            top: 0, 
            width: '210mm', // A4 Width
            background: 'white' 
          }}
        >
          <div ref={this.pdfRef}>
            {this.state.resultDataForPdf && (
              <AdmissionDetailedResultPdf
                studentName={this.state.session?.student_name || "Student"}
                branchName={this.state.session?.branch_name || ""}
                courseName={this.state.session?.course_name || ""}
                totalMarks={this.state.resultDataForPdf.total_marks}
                marksGained={this.state.resultDataForPdf.total_marks_gained}
                subjectAnalytics={this.state.resultDataForPdf.subject_analytics}
                testName={this.state.session?.admission_test || "Admission Test Result"}
                hideDownload={true}
              />
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }

  // ─── MAIN RENDER ───────────────────────────────────────────────────────────
  render() {
    const { loadingQuestions, loadError, showInstructions } = this.state;

    if (loadingQuestions) {
      return (
        <div
          className="sudent_exam_block"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status" />
            <p style={{ color: "#64748b" }}>Loading questions...</p>
          </div>
        </div>
      );
    }

    if (loadError) {
      return (
        <div
          className="sudent_exam_block"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
          }}
        >
          <div className="text-center">
            <p style={{ color: "#ef4444", fontWeight: 600 }}>{loadError}</p>
            <button
              className="btn btn-outline-primary"
              onClick={() => this.props.history.push("/admission-test")}
            >
              ← Back to Home
            </button>
          </div>
        </div>
      );
    }

    return (
      <Beforeunload
        onBeforeunload={() => "Are you sure you want to leave the exam?"}
      >
        {showInstructions ? this.renderInstructions() : this.renderExam()}
      </Beforeunload>
    );
  }
}

export default withRouter(withApollo(AdmissionTestExam));